export type ThemeVariant = 'light' | 'dark' | 'auto';
export type NavPositionVariant = 'horizontal' | 'vertical' | 'combo' | 'dual';
export type NavTopShapeVariant = 'default' | 'slim';
export type NavbarAppearanceVariant = 'default' | 'darker';
export interface Config {
  isNavbarVerticalCollapsed: boolean;
  openNavbarVertical: boolean;
  theme: ThemeVariant;
  navbarVerticalAppearance: NavbarAppearanceVariant;
  navbarTopAppearance: NavbarAppearanceVariant;
  navbarPosition: NavPositionVariant;
  navbarTopShape: NavTopShapeVariant;
  isRTL: boolean;
  isDark: boolean;
  bodyClass?: string;
}

export const initialConfig: Config = {
  isNavbarVerticalCollapsed: false,
  openNavbarVertical: false, // for responsive
  theme: 'light',
  navbarTopAppearance: 'default',
  navbarVerticalAppearance: 'default',
  navbarPosition: 'vertical',
  navbarTopShape: 'default',
  isRTL: false,
  isDark: false
};

/**
 * Calcula la URL del backend dinámicamente según el entorno
 * @returns {string} URL completa del backend incluyendo /api/
 */
export function getBackendUrl(): string {
  const { protocol, hostname, port } = window.location;
  
  // Solo en desarrollo local con puerto 3000, cambiar a 3001
  const isDevLocalhost = (hostname === 'localhost' || hostname === '127.0.0.1') && port === '3000';
  
  if (isDevLocalhost) {
    // Desarrollo: localhost:3000 → localhost:3001
    return `${protocol}//${hostname}:3001/api/`;
  } else {
    // Producción: misma URL + /api/
    return `${protocol}//${hostname}/api/`;
  }
}
